/*
 * Copyright (c) 2022-2026 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import pkgJson from '../../package.json';

// Per-environment values come from env.js, which sets window.__env before the app loads.
// In AKS, nginx serves it from /app/config/env.js: the esci-tools-env ConfigMap in .pipeline/manifest.aks.{env}.yml
// (musea2), or the configMaps entry in eSCI_52471_devops nova/values/*/values-esci-tools-{env}.yaml (Atmos Nova).
// (The Chainguard nginx image has no shell, so values can no longer be written into the bundle at startup.)
interface RuntimeEnv {
    environmentName?: string;
    apiUrl?: string;
    clientId?: string;
    tenantId?: string;
}

const runtimeEnv: RuntimeEnv = (globalThis as typeof globalThis & {__env?: RuntimeEnv}).__env ?? {}; // eslint-disable-line no-underscore-dangle
const runtimeClientId = runtimeEnv.clientId ?? '';

export const environment = {
    production: false,
    fileUploadLimit: 200000000,
    uiVersion: pkgJson.version,
    environmentName: runtimeEnv.environmentName ?? '',
    apiUrl: runtimeEnv.apiUrl ?? '',
    APP_NAME: 'ESCI_TOOLS_UI',
    auth: {
        issuer: `https://login.microsoftonline.com/${runtimeEnv.tenantId ?? ''}/v2.0`,
        clientId: runtimeClientId,
        redirectUri: window.location.origin,
        responseType: 'code',
        scope: `openid profile email ${runtimeClientId}/.default`,
        showDebugInformation: true,
        // turn off validation that discovery document endpoints start with the issuer url defined above
        strictDiscoveryDocumentValidation: false,
        preserveRequestedRoute: true,
    },
};
